import { useSignal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import { InfoIcon } from "components/Icons";
// import IconPopover from "componentsv2/button/IconPopover";

import { getColor } from "./helper";

function getItems(values) {
  return values.map((val, idx) => {
    const isWork = val?.mode ? val.mode === "work" : true;
    const bgColor = isWork ? getColor(val.id) : "#e2e8f0";
    const hasRest = val.start_rest && val.end_rest;

    return (
      <div
        key={idx}
        className="flex items-center gap-x-2 md:gap-x-4 p-2 md:p-3 my-1 rounded-xl shadow-sm border border-neutral-100"
        style={{ backgroundColor: bgColor }}
      >
        <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/60 rounded-lg font-bold text-neutral-700 shadow-inner">
          {val.code}
        </div>
        <div className="flex flex-col min-w-0">
          <span className="font-bold text-neutral-800 tracking-wide text-xs md:text-sm truncate">{val.name}</span>
          <span className="flex text-[10px] md:text-xs text-neutral-600 font-medium mt-0.5">
            {val.start.slice(0, -3)} - {val.end.slice(0, -3)}
            {hasRest && (
                <div className="flex text-gray-500 tracking-wide px-2"> Descanso: {(val.start_rest).slice(0, -3)} - {(val.end_rest).slice(0, -3)} </div>
            )}
          </span>
        </div>
      </div>
    );
  });
}

function ShiftList({ shifts }) {
  const openModal = useSignal(false);

  function handleClose() {
    // openModal.value = false;
  }

  function handleOpen() {
    openModal.value = true;
  }

  return (
    <div className="flex items-center justify-center">
      <button type="button" onClick={handleOpen} className="flex items-center justify-center">
        <InfoIcon
          className="h-7 w-7 md:h-9 md:w-9 fill-current text-neutral-600"
          aria-hidden="true"
        />
      </button>
      <Dialog
        id="modal-shift-list"
        title="staff.shift_scheduling.info"
        openModal={openModal}
        size="w-full md:w-3/4 lg:w-1/2"
        handleClose={handleClose}
      >
        <div className="grid grid-cols-2 gap-2 md:gap-3 mt-4 max-h-[60vh] overflow-y-auto px-1 pb-4">
          {getItems(Array.from(shifts.values()))}
        </div>
      </Dialog>
    </div>
  );
}

export default ShiftList;
